import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {CurveGeometryUnaryMathOperator} from "#template/nodes/geometry-graph/attribute/unary-math-operator/curve-geometry-unary-math-operator"
import {CurveGeometryBinaryMathOperator} from "#template/nodes/geometry-graph/attribute/binary-math-operator/curve-geometry-binary-math-operator"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {GeometryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/math-operator/geometry-math-operator-node"
import {GeometryMathOperatorNode} from "#template/nodes/geometry-graph/attribute/math-operator/geometry-math-operator-node"

export type CurveGeometryMathOperatorParameters = GeometryMathOperatorParameters<CurveGeometryUnaryMathOperator | CurveGeometryBinaryMathOperator>

const definition: TemplateNodeDefinition<CurveGeometryMathOperatorParameters> = {
    nodeClass: "CurveGeometryMathOperator",
    validation: {
        parameters: z.object({
            name: z.string(),
            operator: z.union([graphNode(CurveGeometryUnaryMathOperator), graphNode(CurveGeometryBinaryMathOperator)]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryMathOperator
    extends GeometryMathOperatorNode<1, CurveGeometryUnaryMathOperator | CurveGeometryBinaryMathOperator, CurveGeometryMathOperatorParameters>
    implements CurveGeometryAttributeLikeNode
{
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
